import type { Charts } from '../../types/Charts';

export const chartsBaseFeatureConfig: Charts = {
    numberOfPerformanceChartBars: 5,
    decorateLastYearWithAsterisk: false,
};
